<template>
  <aside aria-label="Support">
    <a
      class="support-bubble fixed flex items-center px-5 py-2 text-white z-40"
      :href="chatbotLink"
      :aria-label="$t('Accessibilty.AriaLabels.GoToSupport')"
    >
      <OSvg svg="question-bubble" class="fill-neutral-00" />
      <p v-if="!iconOnly" class="ota-p14 pl-2" v-text="$t('CustomerService.Support')" />
    </a>
  </aside>
</template>

<script>
import OSvg from '@/components/OSvg'
import { Locales } from '@/enums/general'

export default {
  name: 'SupportBubble',
  components: {
    OSvg
  },
  props: {
    iconOnly: {
      type: Boolean,
      default: false
    },
    locale: {
      type: String,
      default: Locales.NL
    }
  },
  computed: {
    chatbotLink () {
      return `${process.env.CHATBOT_BASE_URL}/${this.locale}`
    }
  }
}
</script>

<style lang="postcss" scoped>
.support-bubble {
  bottom: 2.5rem;
  right: 4rem;
  background-color: #A3A3A3;
  border-radius: 10rem;
}
</style>
